/* Cart panel: quantity stepper, remove line, and a live re-render of the
   whole panel body after any change via Shopify's Section Rendering API
   (?section_id=cart-panel), so totals/lists/checkout amount always stay in
   sync with the real cart instead of being patched by hand in JS. */
document.addEventListener('DOMContentLoaded', function () {
  var panel = document.getElementById('cartPanel');
  if (!panel) return;

  var busy = false;

  function refreshCartCount(cart) {
    // window.updateCartCount (custom.js) also toggles the badge's `hidden`
    // attribute, not just its number — needed so the very first item added
    // to an empty cart actually shows the badge instead of staying hidden.
    if (window.updateCartCount) {
      window.updateCartCount(cart.item_count);
      return;
    }
    document.querySelectorAll('.cart-count').forEach(function (countEl) {
      countEl.textContent = cart.item_count;
      countEl.hidden = cart.item_count === 0;
    });
  }

  function refreshPanel() {
    return fetch(window.location.pathname + '?section_id=cart-panel')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshHeader = doc.getElementById('cartPanel');
        var freshCount = freshHeader ? freshHeader.querySelector('.cart-panel-count') : null;
        var currentCount = panel.querySelector('.cart-panel-count');
        if (freshCount && currentCount) currentCount.textContent = freshCount.textContent;

        var freshBody = doc.getElementById('cartPanelBody');
        var currentBody = document.getElementById('cartPanelBody');
        if (freshBody && currentBody) currentBody.innerHTML = freshBody.innerHTML;

        // #cartPanelFooter, not the bare .cart-panel-footer class — the
        // "Add to" view (sections/cart-panel.liquid) has its own footer
        // earlier in the DOM (.cart-panel-addto-footer, a different
        // class on purpose) so a class-only lookup here would silently
        // grab the wrong element.
        var freshFooter = doc.getElementById('cartPanelFooter');
        var currentFooter = document.getElementById('cartPanelFooter');
        if (freshFooter && currentFooter) {
          currentFooter.innerHTML = freshFooter.innerHTML;
        } else if (freshFooter && !currentFooter) {
          panel.insertAdjacentHTML('beforeend', freshFooter.outerHTML);
        } else if (!freshFooter && currentFooter) {
          currentFooter.remove();
        }

        // #cartPanelBody was just wholesale-replaced above, which wipes
        // any client-rendered content living inside it (e.g. "Your lists"
        // — see the "My Lists" module in assets/the-circle.js) — this
        // lets that module know it needs to re-populate its container.
        document.dispatchEvent(new CustomEvent('vro:cart-panel-refreshed'));
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(refreshCartCount);
  }

  // Deliberately /cart/update.js (an { updates: { <line-item key>: qty } }
  // map) instead of /cart/change.js's { line: <position>, quantity } form.
  // Verified directly against this store's Cart API (bypassing this file
  // entirely) that /cart/change.js's line-position removal has a real bug
  // here: removing one line zeroes out every other line in the cart too.
  // /cart/update.js keyed by the line-item's own key does not have that
  // problem and only ever touches the one line it's given.
  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    var row = panel.querySelector('[data-cart-key="' + key + '"]');
    if (row) row.style.opacity = '.5';

    var updates = {};
    updates[key] = quantity;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        return refreshPanel();
      })
      .catch(function () {
        if (row) row.style.opacity = '';
      })
      .finally(function () { busy = false; });
  }

  panel.addEventListener('click', function (e) {
    var row = e.target.closest('[data-cart-key]');
    if (!row) return;
    var key = row.getAttribute('data-cart-key');
    var qtyEl = row.querySelector('[data-cart-qty-value]');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;

    if (e.target.closest('[data-cart-qty-increase]')) {
      changeLine(key, qty + 1);
    } else if (e.target.closest('[data-cart-qty-decrease]')) {
      changeLine(key, Math.max(0, qty - 1));
    } else if (e.target.closest('[data-cart-remove]')) {
      changeLine(key, 0);
    }
  });

  // The panel's markup is only ever rendered server-side at page load (or
  // after refreshPanel() following a qty/remove change inside the panel
  // itself). Opening it just toggles visibility — theme.liquid's own
  // openPanel() has no idea the cart changed in the meantime, e.g. via the
  // header's quick-add "+" buttons or the PDP form. So without this, the
  // panel can show a stale "cart is empty" snapshot from page load even
  // though the header badge (which every add path already updates) is
  // showing the correct, current count. Refresh on every open to guarantee
  // the panel always matches reality, not just after an in-panel action.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-panel-open]')) refreshPanel();
  });
});
